module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_9_5.9baf3ec5.png";